import React, { useState } from 'react';
import Sidebar from '../../../sidebar/sidebar';

/** Column width for the sidebar, expanded and collapsed to its icon rail. */
const EXPANDED = '0 0 21%';
const COLLAPSED = '0 0 60px';

/**
 * Page frame for the meters pages: a sidebar that holds its place while the
 * page scrolls, beside a content column that reflows when the sidebar
 * collapses.
 *
 * The frame owns the sidebar's open state, because the sidebar reports its own
 * state rather than accepting one and the column has to follow it. A fixed
 * column width leaves a band of empty page beside a collapsed sidebar.
 *
 * Scrolling happens inside the frame rather than on the page, which is what
 * gives the sidebar a container to pin against; on the page there is nothing
 * holding it and it scrolls away with everything else.
 *
 * The content column sits at `flex-start` so it keeps its content's height.
 * Stretched to the frame it would be exactly one viewport tall with its
 * content spilling outside that box, and a sticky header inside it would
 * unpin as soon as you scrolled past the first screenful — a sticky element
 * pins within its parent's padding box, not within the overflow.
 *
 * @param {string} className - Classes for the frame, carrying page-scoped styles.
 * @param {string} contentClassName - Classes for the content column.
 * @param {React.ReactNode} children - The page rendered beside the sidebar.
 */
const MetersPageShell = ({ className = '', contentClassName = '', children }) => {
  const [expanded, setExpanded] = useState(true);

  return (
    <div
      className={`d-flex flex-row mainclass ${className}`.trim()}
      style={{ height: '100vh', overflow: 'auto' }}
    >
      <div
        className="im-shell-sidebar"
        style={{
          flex: expanded ? EXPANDED : COLLAPSED,
          position: 'sticky',
          top: 0,
          zIndex: 999,
        }}
      >
        <Sidebar onSidebarToggle={setExpanded} />
      </div>

      <div
        className={contentClassName}
        style={{ flex: 1, alignSelf: 'flex-start', transition: 'all 0.3s ease' }}
      >
        {children}
      </div>
    </div>
  );
};

export default MetersPageShell;
